<template>
  <common-dialog ref="dialog" :title="title" width="1000px" @closed="onClosed">
    <el-table size="mini" :data="data" stripe border>
      <el-table-column label="班级" min-width="90">
        <template slot-scope="{row}">
          <span>{{row.Grade + row.Class}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Subject" label="科目名称" />
      <el-table-column label="任课教师" min-width="160px">
        <template slot-scope="{row}">
          <span>{{row.Teacher}}</span>
          <span v-if="row.ClassTeacherId==row.TeacherId">（班主任）</span>
        </template>
      </el-table-column>
      <el-table-column prop="TeacherNumber" label="教师编号" />
    </el-table>
    <template slot="footer">
      <el-button size="mini" type="primary" @click="onExport">导 出</el-button>
      <el-button size="mini" @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [detailsDialogMixin],
  components: { commonDialog },
  data() {
    return {
      api: require("@/api/ed/teach").default,
      data: [],
      params: {},
      title: "导出 教师任课信息",
    };
  },
  methods: {
    getData(params) {
      this.params = params;
      this.$refs.dialog.isLoading = true;
      this.api.list(params).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) this.data = res.Data;
      });
    },
    onExport() {
      this.api.export(this.params);
    },
    onClosed() {
      this.data = [];
      this.params = {};
    },
  },
};
</script>